/* components/ui/Button.jsx — единый Button (// заменяет: зоопарк кнопок прода).
   Варианты: primary / secondary / ghost / danger / subtle.
   Размеры: sm / md / lg. Иконо-кнопка через iconOnly. Состояние loading. */

import React from 'react';
import { Icon } from './Icon.jsx';

  const OWN = ['variant', 'size', 'iconLeft', 'iconRight', 'iconOnly', 'loading', 'disabled', 'className', 'children', 'type'];

  const Button = React.forwardRef(function Button({
    variant = 'secondary', size = 'md', iconLeft, iconRight, iconOnly,
    loading = false, disabled = false, className, children, type = 'button', ...rest
  }, ref) {
    // защита: Babel-standalone не всегда исключает дефолтные/именованные пропсы из ...rest —
    // чистим собственные пропсы вручную, чтобы они не утекали как DOM-атрибуты.
    const dom = { ...rest };
    OWN.forEach((k) => { delete dom[k]; });
    const cls = [
      'btn', `btn--${variant}`, `btn--${size}`,
      iconOnly ? 'btn--icon' : '', loading ? 'is-loading' : '', className || '',
    ].filter(Boolean).join(' ');
    return (
      <button ref={ref} type={type} className={cls} disabled={disabled || loading}
              aria-busy={loading || undefined} {...dom}>
        {loading && <span className="btn__spin"><Icon name="spinner" size={16} /></span>}
        {!loading && iconLeft && <Icon name={iconLeft} size={size === 'sm' ? 14 : 16} />}
        {iconOnly && !iconLeft ? <Icon name={iconOnly} size={size === 'sm' ? 16 : 18} /> : null}
        {children && <span className="btn__label">{children}</span>}
        {!loading && iconRight && <Icon name={iconRight} size={size === 'sm' ? 14 : 16} />}
      </button>
    );
  });

export { Button };
